// styles
import "../themes/common.scss";
import "../themes/css/pages/rewards.scss";
//js
import "../themes/js/common.js";
import "../themes/js/pages/rewards.js";

import { initmanage } from "../javascripts/component/manage.js";

initmanage();